import NodePaginator from "@ext/print/utils/pagination/NodePaginator";
import Paginator from "@ext/print/utils/pagination/Paginator";
import someParentHaveChildNodes from "@ext/print/utils/pagination/utils/someParentHaveChildNodes";

class GalleryPaginator extends NodePaginator<HTMLDivElement> {
	paginateNode() {
		if (this.parentPaginator.tryFitElement(this.node)) return;

		if (someParentHaveChildNodes(this)) {
			this.createPage();
			if (this.parentPaginator.tryFitElement(this.node)) return;
		}

		this._shrinkToFit();
	}

	createPage() {
		this.parentPaginator.createPage();
		return this.parentPaginator.currentContainer;
	}

	private _shrinkToFit() {
		const items = this.node.querySelector<HTMLElement>("[data-gallery-items]");
		const available = this.getUsableHeight() - Paginator.paginationInfo.accumulatedHeight.height;
		const itemsHeight = items?.offsetHeight ?? 0;
		const captionHeight = this.nodeDimension.height - itemsHeight;
		const scale = itemsHeight ? Math.min(Math.max((available - captionHeight) / itemsHeight, 0), 1) : 1;

		items?.style.setProperty("--gallery-scale", String(scale));
		this.parentPaginator.currentContainer.appendChild(this.node);
		this.updateAccumulatedHeightDim({ height: available, marginBottom: 0, marginTop: 0, paddingH: 0 });
	}
}

export default GalleryPaginator;
